import { Placeholder } from "./Placeholder";

export function NotFound() {
  return (
    <Placeholder title="Nicht gefunden" icon="🧭">
      <p class="text-muted" style="margin:0">
        Diese Seite gibt es nicht. <a href="/">Zurück zu Heute</a>
      </p>
    </Placeholder>
  );
}
